export function setupPrototypes () {
	/* #### Global Prototypevs #### */
	String.prototype.reverse = function () {
		return this.split('').reverse().join('')
	}
	String.prototype.dec64 = function () {
		try {
			return decodeURIComponent(atob(this).split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
			}).join(''))
		} catch (err) {
			return ''
		}
	}
	String.prototype.enc64 = function () {
		try {
		return btoa(encodeURIComponent(this).replace(/%([0-9A-F]{2})/g,
			function toSolidBytes (match, p1) {
				return String.fromCharCode('0x' + p1)
			}))
		} catch (err) {
			return ''
		}
	}
	String.prototype.rot13 = function () {
		return this.replace(/[a-zA-Z]/g, function (c) {
			return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26)
		})
	}
	String.prototype.XOR = function (key = 51) {
		var encoded = ''
		for (let i = 0; i < this.length; i++) {
		let a = this.charCodeAt(i)
		let b = a ^ key
		encoded = encoded + String.fromCharCode(b)
		}
		return encoded
	}
	String.prototype.merge = function (merge_with) {
		let c = ''
		let a = Array.from(this)
		let b = Array.from(merge_with)
		while (a.length > 0 || b.length > 0) {
			if (a.length > 0) { c += a.splice(0, 1) }
			if (b.length > 0) { c += b.splice(0, 1) }
		}
		return c
	}
	String.prototype.random = function (length = 10, possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
		let newrandom = ''
		for (let i = 0; i < length; i++) { newrandom += possible.charAt(Math.floor(Math.random() * possible.length)) }
		return newrandom
	}
	String.prototype.internleave = function () { return this.merge(String().random(this.length)) }
	String.prototype.deinterleave = function () {
		let output = ''
		for (let i = 0; i < this.length; i++) {
			if (i % 2 == 0) { output += this[i] }
		}
		return output
	}
	String.prototype.encode = function () {
		let to_encode = `${this}`
		try {
			to_encode = `${to_encode.reverse().internleave()}`
			to_encode = `${String().random(9)}${to_encode}${String().random(11)}`
			to_encode = `${to_encode.rot13().enc64().reverse().rot13()}`
			to_encode = `${String().random(4)}${to_encode}${String().random(3)}`
			to_encode = `${to_encode.enc64()}`
			return to_encode
		} catch (err) {
			return ''
		}
	}
	String.prototype.decode = function () {
		let to_decode = `${this}`
		try {
			to_decode = `${to_decode.dec64()}`
			to_decode = `${to_decode.substring(0, (to_decode.length - 3)).substring(4)}`
			to_decode = `${to_decode.rot13().reverse().dec64().rot13()}`
			to_decode = `${to_decode.substring(0, (to_decode.length - 11)).substring(9)}`
			to_decode = `${to_decode.deinterleave().reverse()}`
			return to_decode
		} catch (err) {
			return ''
		}
	}
	String.prototype.packageCrossDomain = function() {
		let to_package = `${this}`;
		try {
			to_package = `${to_package}Salt123`;
			to_package = `${to_package.enc64()}`;
			//to_package = `${to_package.replace(/[=][=]$/,'')}`;
			to_package = `${to_package.reverse()}`;
			to_package = `${to_package.rot13()}`;
			to_package = `${encodeURIComponent(to_package)}`;
			return to_package;
		} catch (err) {
			return '';
		}
	};
	String.prototype.unPackageCrossDomain = function() {
		let to_unpackage = `${this}`;
		try {
			to_unpackage = `${decodeURIComponent(to_unpackage)}`;
			to_unpackage = `${to_unpackage.rot13()}`;
			to_unpackage = `${to_unpackage.reverse()}`;
			//to_unpackage = `${to_unpackage}==`;
			to_unpackage = `${to_unpackage.dec64()}`;
			to_unpackage = `${to_unpackage.replace(/Salt123$/,'')}`;
			return to_unpackage;
		} catch (err) {
			return '';
		}
	};
	String.prototype.capitalize = function () {
		return `${this.charAt(0).toUpperCase()}${this.slice(1)}`
	}
	Number.prototype.formatMoney = function (c = 2, d = '.', t = ',', p = '$') {
		let n = this
		c = isNaN(c = Math.abs(c)) ? 2 : c
		let s = n < 0 ? '-' : ''
		let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)))
		let j = (j = i.length) > 3 ? j % 3 : 0
		return s + p + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
	}
	String.prototype.padLeft = function (size, pad_char = '0') {
		var s = String(this)
		while (s.length < (size || 2)) { s = pad_char + s }
		return s
	}
	String.prototype.padRight = function (size, pad_char = '0') {
		var s = String(this)
		while (s.length < (size || 2)) { s = s + pad_char }
		return s
	}
	Date.prototype.daysUntil = function (new_date) {
		let a_day = 1000 * 60 * 60 * 24
		let date1_ms = this.getTime()
		let date2_ms = new_date.getTime()
		var difference_ms = date2_ms - date1_ms
		return Math.ceil(difference_ms / a_day)
	}
	Date.prototype.getMonthName = function () {
		var months = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec')
		return months[this.getMonth()]
	}
	Date.prototype.getMonthNameLong = function () {
		var months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December')
		return months[this.getMonth()]
	}
	Date.prototype.getDayName = function () {
		var days = new Array('Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat')
		return days[this.getDay()]
	}
	Date.prototype.getDayNameLong = function () {
		var days = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday')
		return days[this.getDay()]
	}
}
